// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c2b4b54f","455":"1b60ae15","977":"5a80f991"}[chunkId] + ".chunk.js";
};